module.exports = __webpack_public_path__ + "img/avg_premium_filled.dc82d45.svg";